import { ParentTable } from "./ParentTable";

export const Parent = () => (
  <section>
    <ParentTable />
  </section>
);
